// Simple throttle utility function
// Usage: const throttledFn = throttle(fn, 300);
export const throttle = (func, limit) => {
  let inThrottle = false;
  return function (...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => {
        inThrottle = false;
      }, limit);
    } else {
      // For debugging, you can log throttled calls
      // console.log("Emoji spawn attempt throttled.");
    }
  };
};
